import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardSubtitle, Form, Container, Button, Alert, Modal, Table, UncontrolledTooltip } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Link, useHistory } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader'
import Tasks from "../Dashboard/tasks"


    const AddLeaveRequest = () => {

        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [empTitle, setEmpTitle] = useState('');
        const [gender, setGender] = useState('');
        const [isloading, setIsloading] = useState(false);
        const [yourLeaves, setYourLeaves] = useState([])
        const [leaveCategory, setLeaveCategory] = useState('')
        const [telephone, setTelephone] = useState('')
        const [leaveAddress, setLeaveAddress] = useState('')
        const [selectedDates, setSelectedDates] = useState([])
        const [fileData, setFileData] = useState(null);
        const [CompanyID, setCompanyID] = useState("")
        const [modal_line, setmodal_line] = useState(false)
        const [causesofabsence, setCausesofAbsence] = useState([])
        const [cCode, setCCode] = useState('')
        const [leaveLines, setLeaveLines] = useState([])
        const [documentID, setDocumentID] = useState('')
        const history = useHistory();

        toastr.options = TOAST_OPTIONS;
        const [inputs, setInputs] = useState([]);
        const handleChange = (event) => {
             const name = event.target.name;
             const value = event.target.value;
             setInputs(values => ({...values, [name]: value}));
        }
        const addLine = () =>{
            setLeaveLines(prescItems => [...prescItems, { Start_Date: formatDate(selectedDates[0]), Return_Date: formatDate(selectedDates[1]), Leave_Type: (cCode)}]);
            tog_line()
            setSelectedDates('')
            setCCode('')
        }
        const handleSubmit = (event) => {
            event.preventDefault();
            if (empNo == ""){
                toastr.error("Failed to get employee number! Please refresh or contact your system Administrator!");
            }
            let data = {}
            if(leaveCategory == 'ANNUAL'){
                data = {
                    Employee_No         : empNo,
                    Telephone_Number    : telephone,
                    Leave_Address       : leaveAddress,
                    From_Date           : formatDate(selectedDates[0]),
                    To_Date             : formatDate(selectedDates[1]),
                    Annual_Leave_WS     : 'YES' 
                }
            }else{
                data = {
                    employeeNo         : empNo,
                    leaveRequestLines  : leaveLines,
                }
            }          
            setIsloading(true)
            axios.post(url.LEAVE_REQUESTS +"?company="+ CompanyID, JSON.stringify(data), HRConfig)
                .then(function(response){     
                    if(response.data.no){
                        setDocumentID(response.data.SystemId)
                        toastr.success("Leave Request No "+ response.data.no+" created" ); 
                        setTimeout(function(){ history.push(`/leave-request-details/${response.data.SystemId}`)} ,3000 );
                    }else{
                        toastr.error("Could not Create leave request" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    console.log(error)
                    toastr.error(error.response.data.error.message);
                    setIsloading(false)
            })

        }
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_line = () => {
            setmodal_line(!modal_line);
            removeBodyCss();
        }
        const handleRemoveItem = (k)=>{
            const newItems = [...leaveLines];
            newItems.splice(k, 1);
            setLeaveLines(newItems);
        }
        
        const [userError, setUserError] = useState(true);
        const handleFileChange = (event) => {
            const file = event.target.files[0];
            const reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onload = () => {
              // Encode the data as Base64
              const data_b64 = btoa(reader.result);
        
              // Create a JSON object with the file data
              const json_data = {
                filename: file.name,
                data: data_b64,
              };
        
              // Update the file data state
              setFileData(json_data);
            };
          };
        useEffect(() => {
            if (localStorage.getItem("authMildUser")) {
                const obj = JSON.parse(localStorage.getItem("authMildUser"));
                const EmployeeNo = obj.uid;
                setCompanyID(obj.activeCompany);  
                axios.get(url.EMPLOYEES2 + "?$filter=No eq '"+ EmployeeNo +"'&company="+ obj.activeCompany, HRConfig)
                    .then(function(response){
                        if(response.data.value.length > 0){
                            setEmpNo(response.data.value[0].No);
                            setEmpName(response.data.value[0].FirstName + " " + response.data.value[0].MiddleName+ " " + response.data.value[0].LastName);
                            setEmpTitle(response.data.value[0].JobTitle);
                            setGender(response.data.value[0].Gender);

                            document.addEventListener("DOMContentLoaded", function(event) {
                                document.getElementsByClassName('btnSubmitRequest')[0].disabled = false;
                            });
                            
                            const leave = [
                                {
                                  'leaveType': 'Annual', 
                                  'entitled':(response.data.value[0].AnnualLeaveDaysEntitlement),
                                  'used': (response.data.value[0].AnnualLeaveDaysUsed),
                                  'balance': (response.data.value[0].AnnualLeaveDaysEntitlement) - (response.data.value[0].AnnualLeaveDaysUsed)

                                },
                                {
                                  'leaveType': 'Bereavement', 
                                  'entitled':(response.data.value[0].CompationateLeaveEntitlement),
                                  'used': (response.data.value[0].CompassionateDaysUsed),
                                  'balance': (response.data.value[0].CompationateLeaveEntitlement)-(response.data.value[0].CompassionateDaysUsed)
                                },
                                {
                                  'leaveType': 'Sick', 
                                  'entitled':(response.data.value[0].SickLeaveEntitilement),
                                  'used': (response.data.value[0].SickLeaveDaysused),
                                  'balance': (response.data.value[0].SickLeaveEntitilement)-(response.data.value[0].SickLeaveDaysused)
                                },
                                {
                                  'leaveType': 'Study', 
                                  'entitled':(response.data.value[0].StudyLeaveEntitlement),
                                  'used': (response.data.value[0].StudyLeaveDaysUsed),
                                  'balance': (response.data.value[0].StudyLeaveEntitlement)-(response.data.value[0].StudyLeaveDaysUsed)
                                },                                {
                                    'leaveType': 'UnPaid', 
                                    'entitled':(response.data.value[0].UnpaidLeaveEntitlement),
                                    'used': (response.data.value[0].UnPaidDaysUsed),
                                    'balance': (response.data.value[0].UnpaidLeaveEntitlement)-(response.data.value[0].UnPaidDaysUsed)
                                }
                            ];
                              
                            if(response.data.value[0].gender == 'Male'){
                                leave.push(
                                    {
                                        'leaveType': 'Paternity', 
                                        'entitled': (response.data.value[0].PaternityLeaveEntitlement),
                                        'used': (response.data.value[0].PaternityDaysUsed),
                                        'balance': (response.data.value[0].PaternityLeaveEntitlement) - (response.data.value[0].PaternityDaysUsed)
                                    }
                                )
                            }else{
                                leave.push(
                                    {
                                        'leaveType': 'Maternity', 
                                        'entitled': (response.data.value[0].MaternityLeaveEntitilement),
                                        'used': (response.data.value[0].MaternityDaysUsed),
                                        'balance': (response.data.value[0].MaternityLeaveEntitilement) - (response.data.value[0].MaternityDaysUsed)
                                    }
                                )
                            }

                            setYourLeaves(leave)
                            setUserError(false);
                        }else{
                            toastr.error("Employee Details Not Found in Business Central");
                        }
                    }).catch(function (error) {
                        toastr.error(error.response.data.error.message);
                        setUserError(true);
                    })
                    .then(function () {
                    // always executed
                });
                axios.get(url.CAUSES_OF_ABSENCE +"?company=" +obj.activeCompany, HRConfig).then((r)=>{ setCausesofAbsence(r.data.value) }).catch((e)=>{ console.log(e) })

            }
        },[]);

        
        

        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<ClimbingBoxLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Add Leave Request | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Add Leave Request" />
                        <Form onSubmit={handleSubmit}>
                        {userError && ( 
                            <Alert color="danger" role="alert">
                                    Your Employee Number Not Found in Dynamics 365 Business Central
                            </Alert>
                        )}
                        <Row>
                        <Col xl={4}>
                        <Card>
                            <CardBody>
                            <CardTitle>Employee Details</CardTitle>
                                <div className="table-responsive">
                                    <table className="table">
                                        <tbody>
                                            <tr>
                                                <th scope="col"> Number</th>
                                                <td scope="col"> {empNo} </td>
                                            </tr>
                                            <tr>
                                                <th scope="col"> Name</th>
                                                <td scope="col">{empName}</td>
                                            </tr>
                                            <tr>
                                                <th scope="col">Position</th>
                                                <td scope="col">{empTitle}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Gender</th>
                                                <td>{gender}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </CardBody>
                            </Card>
                            <div className="d-flex">
                                <div className="flex-grow-1 ms-1">                                 
                                    <ul className="list-unstyled vstack gap-2 mb-0">
                                        <div className="d-grid gap-2">
                                            <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{tog_line()}} >
                                                <i className="mdi mdi-calendar-edit"/>{" "}
                                                    Add Leave Request Line
                                            </Button>
                                            {(leaveLines.length > 0) && (
                                            <Button color="primary" type="submit" className="btn btnSubmitPlan">
                                                <i className="mdi mdi-content-save-all-outline"/>{" "}
                                                    Save Leave Request
                                            </Button>
                                            )}
                                        </div>
                                    </ul>
                                </div>
                            </div>
                            </Col>

                            <Col xl={8}>
                                <Tasks leave={yourLeaves} showReports={false}/>
                            
                            <Col xl={12}>
                            <Card>
                                <CardBody>
                                    <CardTitle className= "mb-3 mt-1 justify-content-center">
                                        Leave Request Lines
                                    </CardTitle>

                                    <CardBody className="border-bottom">
                                        {(leaveLines.length > 0) ? (
                                            <div className="table-responsive">
                                                <Table  className="table table-striped table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Leave Type</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Start Date</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>End Date</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}></th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {leaveLines.map((a,k)=>(
                                                            <tr key={k}>

                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Leave_Type}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Start_Date}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Return_Date}</td> 
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> 
                                                                    <div className="d-flex gap-3">     
                                                                        <Link
                                                                            to="#"
                                                                            className="text-danger"
                                                                            onClick={() => handleRemoveItem(k)}
                                                                        >
                                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                            <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                                Delete
                                                                            </UncontrolledTooltip>
                                                                        </Link>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-calendar-edit text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No Leave Request Lines added, yet!</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                    )}
                                </CardBody>
                                   
                            <Modal isOpen={modal_line} toggle={() => { tog_line(); }}  size="l" centered  backdrop={'static'}  >
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Add Leave Line` }</h5>
                                    <button type="button"  onClick={() => { setmodal_line(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    
                                    <Row>
                                    <Col md={12}>
                                            <div className="mb-3">
                                                <label htmlFor="floatingIdInput">Leave Type</label>
                                                <select className="form-select" value={cCode} onChange={(e)=>setCCode(e.target.value)}>
                                                    <option value=""></option>
                                                    {causesofabsence.map((c,k)=>(
                                                        <option key={k} value={c.Code}>{c.Description}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                    <Col md={12}>
                                            <div className="mb-3">
                                            <label htmlFor="floatingDepartInput">Start Date - End Date</label>
                                            <Flatpickr
                                                className="form-control"
                                                placeholder="dd M,yyyy"
                                                options={{
                                                    mode: "range",
                                                    dateFormat: "Y-m-d"
                                                }}
                                                value={selectedDates}
                                                onChange={(dates) =>{setSelectedDates(dates)} }
                                                />
                                            
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                
                                <div className="modal-footer">
                                {isloading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                    : ( <button type="button" className="btn btn-success" onClick={addLine}>Add line...</button> )
                                }</div>
                                </Modal> 

                         
                        
                                </CardBody>
                            </Card>
                            </Col>
                        </Col>
                        
                        </Row>
                        </Form>


                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default AddLeaveRequest;